module.exports = __webpack_public_path__ + "img/tick.8af7c79f.svg";